export const sortStepsByMajor = (item) => {
  const stepNumber = item.step;
  if (!stepNumber) {
    return -1;
  }
  const dotIdx = stepNumber.indexOf('.');
  const major = dotIdx < 0 ? stepNumber : stepNumber.substring(0, dotIdx);
  return Number(major);
};

export const sortStepsByMinor = (item) => {
  const stepNumber = item.step;
  if (!stepNumber) {
    return -1;
  }
  const dotIdx = stepNumber.indexOf('.');
  const minor = dotIdx < 0 ? 0 : stepNumber.substring(dotIdx + 1);
  return Number(minor);
};
